import { render } from "./CallInDidCome.vue?vue&type=template&id=2424272d"
import script from "./CallInDidCome.vue?vue&type=script&lang=js"
export * from "./CallInDidCome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__